module.exports = __webpack_public_path__ + "img/credit@2x.cc0dc687.png";